import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import moment from "moment"
import "moment/locale/fr"
import React from "react"
import { MaDispoInfoSheet } from "./MaDispoInfoSheet"

/**
 * How long a créneau commits the tutor, ADAPTIVE to today: between 1 April and
 * 15 June it runs « jusqu'au 30 juin » (school year end, summer lives then take
 * over — a hand-off the tutor does not need spelled out here); otherwise 3 months.
 *
 * Returns the DURATION alone, so the sentence around it stays one clause.
 */
const continuityText = () => {
    const now = moment()
    const year = now.year()
    const springStart = moment(`${year}-04-01`, "YYYY-MM-DD")
    const springEnd = moment(`${year}-06-15`, "YYYY-MM-DD")
    // Compared by DAY: both bounds are inclusive dates, and the default
    // millisecond comparison put 15 June at 00:00 — so from one second past
    // midnight the tutor read « 3 prochains mois » on a day inside the window.
    if (
        now.isSameOrAfter(springStart, "day") &&
        now.isSameOrBefore(springEnd, "day")
    ) {
        return "jusqu'au 30 juin, fin de l'année scolaire"
    }
    return "pendant 3 mois"
}

/**
 * The « un créneau régulier, c'est un engagement » sheet — the one warning the
 * tutor sees before their week starts being proposed to families.
 *
 * Shared so the standalone screen and the profile stepper show the SAME words:
 * what the tutor commits to must not depend on where they declared it. Only the
 * decision differs, hence the labels are the caller's — « Confirmer ma dispo » on
 * the screen, where it saves; « Continuer » in the stepper, where it advances.
 */
export const MaDispoContinuitySheet = ({
    visible,
    onClose,
    confirmLabel,
    onConfirm,
    cancelLabel,
    onCancel,
    loading,
}) => (
    <MaDispoInfoSheet
        visible={visible}
        onClose={onClose}
        title="Un créneau régulier, c'est un engagement"
        body={
            <TextM
                wrap
                fontSize={14}
                color={theme.colors.grey}
                style={{ textAlign: "center", lineHeight: 21 }}
            >
                Un créneau que tu poses, tu t'engages à le tenir{" "}
                <TextM fontWeight="Bold" fontSize={14}>
                    {continuityText()}
                </TextM>
                . Les familles s'inscrivent sur la durée.
            </TextM>
        }
        confirmLabel={confirmLabel}
        onConfirm={onConfirm}
        cancelLabel={cancelLabel}
        onCancel={onCancel}
        loading={loading}
    />
)
